export default class CAAA1040RequestModel {}
